import Navbar from "../../navbar/Navbar";
import "../../css/userPage/UserPage.css"
import {useEffect, useState} from "react";
import LocationCode from "../../utils/constants/LocationCode";
import AdminMenuId from "../../utils/constants/AdminMenuId";
import UserContent from "./UserContent";

let UserPage = (props) => {
    let [location, setLocation] = useState(LocationCode.NOT_LOADING);
    let [currentMenu, setCurrenetMenu] = useState(AdminMenuId.TABLE);

    useEffect(() => {
        setLocation(props.myInformation.location)
    }, [props.myInformation])
    return (<>
        <Navbar location={location} onLocationChange={() => {
        }}
                currentMenu={currentMenu}
                onMenuChange={setCurrenetMenu.bind(this)}
                onLoginChange={props.onLoginChange} isAdmin={false}
                myInformation={props.myInformation}
        ></Navbar>
        <UserContent currentMenu={currentMenu} data={props.data} location={location}
                     myInformation={props.myInformation} setNeedInfoRefresh={props.setNeedInfoRefresh}></UserContent>
    </>)
}
export default UserPage;